// extracted by mini-css-extract-plugin
export var container = "styles-module--container--2G2Fy";
export var sectionTitle = "styles-module--sectionTitle--15I_G";
export var projectList = "styles-module--projectList--3uZqG";